import { createContext, useContext } from 'react'
import { OpenDialog, useDialog } from '../hooks/dialog/dialog.hook'
import { Dialog, Typography } from '@yuno/design-system-web'
import styled from '@emotion/styled'

interface Texts {
  text1?: string
  text2?: string
}
interface Props {
  title: JSX.Element | string
  closeIcon: () => void
  open: boolean
  buttons: IButton[]
  texts: Texts
  onOpenDialog: OpenDialog
}
interface IButton {
  variant: 'text' | 'outlined' | 'contained'
  label: string
  event: () => void
  size: 'small' | 'large' | 'medium'
}

const DialogContext = createContext<Props>({
  title: null,
  closeIcon: null,
  open: false,
  buttons: null,
  texts: {},
  onOpenDialog: null,
})

const TypographyStyled = styled(Typography)`
  margin-bottom: 20px;
`
export const DialogProvider = ({ children }) => {
  const {
    title,
    closeIcon,
    open,
    buttons = [],
    texts,
    onOpenDialog,
    allowed,
  } = useDialog()

  return (
    <DialogContext.Provider
      value={{ title, closeIcon, open, buttons, texts, onOpenDialog }}
    >
      <Dialog
        title={title}
        closeIcon={closeIcon}
        open={open}
        buttons={buttons}
        allowed={allowed}
      >
        <div>
          <TypographyStyled>{texts?.text1}</TypographyStyled>
          <Typography>{texts?.text2}</Typography>
        </div>
      </Dialog>
      {children}
    </DialogContext.Provider>
  )
}
export const useDialogContext = () => useContext(DialogContext)
